export default "__VITE_ASSET__C_0d6QAW__"